import React, { PropsWithChildren } from 'react';
import styles from './ModalTitle.module.scss';

type ModalTitleOwnProps = {
  /** `className` is used to style how `ModalTitle` text is positioned.
   * @default display: inline-flex; width: -webkit-fill-available; margin: 4px 16px 16px; */
  className?: string;
  /** `textClassName` is used to style how `ModalTitle` text looks,
   * @default font-width: 600; font-size: $REG_XXL; color: $mainWhite; text-align: left; */
  textClassName?: string;
};

type ModalTitleProps = PropsWithChildren<ModalTitleOwnProps>;

const ModalTitle: React.FC<ModalTitleProps> = ({ className = '', textClassName, children }) => {
  const baseCls = `${styles.ModalTitleContainer} ${className}`;
  const textCls = textClassName ?? styles.ModalTitle;
  return (
    <div className={baseCls}>
      <span className={textCls} aria-description="title of the modal dialog / drawer">
        {children}
      </span>
    </div>
  );
};

export default ModalTitle;
